import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '../../themes';

const MobileMediaQuery = styled.div`
  @media only screen and (max-width: ${theme.mobileMaxWidthEm}) {
    display: block;
  }

  @media only screen and (min-width: ${theme.mobileMaxWidthEm}) {
    display: none;
  }
`;

const DesktopMediaQuery = styled.div`
  @media only screen and (max-width: ${theme.mobileMaxWidthEm}) {
    display: none;
  }

  @media only screen and (min-width: ${theme.mobileMaxWidthEm}) {
    display: block;
  }
`;

const Breakpoint = ({ mobile, children }) => {
  if (mobile) {
    return (
      <MobileMediaQuery>
        {children}
      </MobileMediaQuery>
    );
  }

  return (
    <DesktopMediaQuery>
      {children}
    </DesktopMediaQuery>
  );
};

Breakpoint.propTypes = {
  children: PropTypes.node,
  mobile: PropTypes.bool,
};

Breakpoint.defaultProps = {
  children: null,
  mobile: false,
};

export default Breakpoint;



// WEBPACK FOOTER //
// ./src/app/components/breakpoint/index.js